import styled, { css } from "styled-components";

export const WrapperFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 25%;
`;